module.exports = __webpack_public_path__ + "static/img/car.42e2784.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/car.png
// module id = gKLg
// module chunks = 1